import React, { Component } from "react";
import RemoteTable from "../../../../components/Common/RemoteTable";
import queryString from "query-string";
import DynamicFormMultipleFilter from "../../../../components/forms/DynamicFormMultipleFilter";
import { Col, Form, Row } from "reactstrap";
import PropTypes from "prop-types";
import CustomCurrencySelect from "../../../../components/CustomCurrencySelect/CustomCurrencySelect";

class InspectionReportList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedCurrency: null,
      selectedOffers: null,
      selectedPlatforms: null,
    }
  }

  onFilterDateRangeChange = filter => {
    const parsedSearch = queryString.parse(this.props.history.location.search);
    const dt = {
      currency: parsedSearch.currency,
      start_date: filter.start_date,
      end_date: filter.end_date
    };

    let formQueryString = queryString.stringify(
      Object.assign(parsedSearch, {
        start_date: filter.start_date,
        end_date: filter.end_date
      })
    );

    this.props.history.push({
      ...this.props.history.location,
      search: formQueryString
    });
    this.props.setPaymentCostInspectionDate(dt);
    this.props.getPaymentCostInspectionReportList(dt);
  };

  onFilterSelectChange = (data, item) => {
    const prevSearch = queryString.parse(this.props.history.location.search);
    const dt = {
      [item.key]:
        item.filterType === "media_source"
          ? data.map(i => i.value)
          : data.map(i => i.value),
      start_date: this.props.inspectionDate.start_date,
      end_date: this.props.inspectionDate.end_date,
      currency: prevSearch.currency,
    };
    let formQueryString = queryString.stringify(
      Object.assign(prevSearch, {
        [item.key]: data.map(i => i.value),
        start_date: this.props.inspectionDate.start_date,
        end_date: this.props.inspectionDate.end_date
      })
    );
    this.props.history.location.search = formQueryString;
    this.props.history.replace(this.props.history.location);
    this.props.setPaymentCostInspectionDate(dt);
    this.props.getPaymentCostInspectionReportList(dt);
  };

  onCurrencyChange = data => {
    const updateData = this.props.inspectionDate;
    let prevHistory = queryString.parse(this.props.history.location.search);
    let formQueryString = queryString.stringify(
      Object.assign(prevHistory, {
        start_date: this.props.inspectionDate.start_date,
        end_date: this.props.inspectionDate.end_date,
        currency: data.value
      })
    );
    updateData.currency = data.value;

    this.setState({
      selectedCurrency: data.value
    })
    this.props.history.location.search = formQueryString;
    this.props.history.replace(this.props.history.location);
    this.props.getPaymentCostInspectionReportList(updateData);
  };

  handleTableChange = data => {
    this.props.getPaymentCostInspectionReportList(data);
  };


  render() {

    const columns = [
      {
        dataField: "platform",
        text: "Platform",
        sort: false
      },
      {
        dataField: "payment_sum",
        text: "Payment",
        sort: false
      },
      {
        dataField: "spend_sum",
        text: "Cost",
        sort: false
      },
      {
        dataField: "rebates",
        text: "Rebates",
        sort: false
      },
      {
        dataField: "balance",
        text: "Balance",
        sort: false
      }
    ];

    return (
      <React.Fragment>
        <DynamicFormMultipleFilter
          onFiltersChange={this.onFilterDateRangeChange}
          onFilterSelect={this.onFilterSelectChange}
          filtersFields={[
            {
              filterData: this.props.inspectionFilters.offers || [],
              plug: "Offers...",
              key: "offer_id",
              filterType: "offer_id"
            },
            {
              filterData: this.props.inspectionFilters.media_sources || [],
              plug: "Platform...",
              key: "media_source",
              filterType: "media_source"
            }
          ]}
          selectedDate={[]}
          filtered_params={queryString.parse(
            this.props.history.location.search
          )}
          filtered_by={["offer_id", "platform"]}
          dateFilters={[
            {
              value: {
                start_date: this.props.inspectionDate?.start_date,
                end_date: this.props.inspectionDate?.end_date
              },
              isTitle: false,
              plug: "Date range",
              key: "date_range"
            }
          ]}
          style={{ padding: "0.5rem 0" }}
          isTitle={false}
          name="list"
        />
        <Row>
          <Col className="col-12">
            <Form className="row float-end">
              <div className="col-sm-auto">
                <CustomCurrencySelect
                  options={this.props.currency}
                  onChange={this.onCurrencyChange}
                  defaultValue={queryString.parse(
                    this.props.history.location.search
                  )}
                />
              </div>
            </Form>
          </Col>
        </Row>
        <Row>
          <Col className="col-12">
            <RemoteTable
              onTableChange={this.handleTableChange}
              columns={columns}
              data={this.props.data}
              loading={this.props.loading}
              search_input={false}
              disable_pages
            />
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

InspectionReportList.propTypes = {
  data: PropTypes.any,
  inspectionDate: PropTypes.any,
  inspectionFilters: PropTypes.any,
  currency: PropTypes.any,
  loading: PropTypes.bool,
  getPaymentCostInspectionReportList: PropTypes.func,
  setPaymentCostInspectionDate: PropTypes.func,
  history: PropTypes.any,
  permissions: PropTypes.any
};

export default InspectionReportList;